// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MAP6x","question":"styles_question__3EyHw","description":"styles_description__R8JSj"};